import { useEffect, useState } from "react";
import TextField from "@mui/material/TextField";
import SuiBox from "components/SuiBox";
import SuiButton from "components/SuiButton";
// import Swal from "sweetalert2";
import { Link, useNavigate } from "react-router-dom";
import { Alert, Box, Snackbar, Typography } from "@mui/material";
import { checkUsernameAndPassword, changePassword } from "api/api_register2FA";
import useEnterKeyEvent from "hooks/useEnterKeyEvent";
import refreshButton from "assets/images/refreshButton.png";
import InputPassword from "components/InputPassword";
import HandleGenCapchaRandomRotate from "../forgot/component/Capcha/Capcha";

function ChangePass() {
  const [userName, setUserName] = useState("");
  const [isLoginFail, setIsLoginfail] = useState(false);
  const [captchaInput, setCaptchaInput] = useState("");
  const [typePasswordOld, setTypePasswordOld] = useState("");
  const [typePasswordNew, setTypePasswordNew] = useState("");
  const [reTypePasswordNew, setReTypePasswordNew] = useState("");
  const [error, setError] = useState("");
  const [captchaImg, setcaptchaImg] = useState("");
  const [passwordRules, setPasswordRules] = useState([
    { label: "Có ít nhất 8 ký tự", status: false },
    { label: "Có cả IN HOA và thường", status: false },
    { label: "Có ít nhất một số", status: false },
    { label: "Và một ký tự đặc biệt: !@#$%^&*", status: false },
  ]);

  const handleGenCapcha = () => {
    const charset = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz";
    let result = "";

    for (let i = 0; i < 3; i += 1) {
      const randomIndex = Math.floor(Math.random() * charset.length);
      result += charset.charAt(randomIndex);
    }
    setcaptchaImg(result);
  };

  useEffect(() => {
    handleGenCapcha();
  }, []);

  const validatePassword = (password) => {
    const rulesCopy = [...passwordRules];
    rulesCopy[0].status = password.length >= 8;
    rulesCopy[1].status = /[a-z]/.test(password) && /[A-Z]/.test(password);
    rulesCopy[2].status = /\d/.test(password);
    rulesCopy[3].status = /[!@#$%^&*]/.test(password);

    setPasswordRules(rulesCopy);

    return rulesCopy.every((rule) => rule.status);
  };
  const navigate = useNavigate();

  const handleLogin = async () => {
    const checkUserAndPwd = await checkUsernameAndPassword(userName, typePasswordOld.password);
    if (!checkUserAndPwd) {
      setIsLoginfail(true);
      setError("Tên đăng nhập hoặc mật khẩu không đúng.");
      return;
    }
    const changePass = await changePassword(userName, typePasswordNew.password);
    if (changePass) {
      alert("Đổi mật khẩu thành công.");
      navigate("/authentication/sign-in");
    } else {
      setIsLoginfail(true);
      setError("Đổi mật khẩu thất bại.");
    }
  };

  const handleLoginAttempt = () => {
    if (!userName || !typePasswordOld || !typePasswordNew || !reTypePasswordNew || !captchaInput) {
      setIsLoginfail(true);
      setError("Vui lòng điền đầy đủ thông tin.");
      return;
    }
    if (typePasswordNew.password !== reTypePasswordNew.password) {
      setIsLoginfail(true);
      setError("Mật khẩu mới và mật khẩu nhập lại không khớp.");
      return;
    }

    if (!validatePassword(typePasswordNew.password)) {
      setIsLoginfail(true);
      setError("Mật khẩu mới phải đủ 8 ký tự, có cả chữ IN HOA, chữ thường, số và ký tự đặc biệt.");
      return;
    }
    if (captchaInput !== captchaImg) {
      setIsLoginfail(true);
      setError("Mã CAPTCHA không đúng.");
      return;
    }
    handleLogin();
  };

  useEnterKeyEvent([userName, captchaInput], handleLoginAttempt);
  const [isBackButtonClicked, setBackbuttonPress] = useState(false);
  const onBackButtonEvent = (e) => {
    e.preventDefault();
    if (isBackButtonClicked) {
      setBackbuttonPress(false);
    } else {
      window.history.pushState(null, null, window.location.pathname);
      setBackbuttonPress(true);
    }
  };

  useEffect(() => {
    window.history.pushState(null, null, window.location.pathname);
    window.addEventListener("popstate", onBackButtonEvent);
    return () => {
      window.removeEventListener("popstate", onBackButtonEvent);
    };
  }, []);
  const handleCloseNotifyLogin = () => setIsLoginfail(false);
  return (
    <Box style={{ width: "550px" }} className="form-container">
      <SuiBox sx={{ display: "flex", alignItems: "center" }} className="flex-column">
        <Typography sx={{ fontWeight: 700, fontSize: 25 }}>Đổi mật khẩu</Typography>
        <SuiBox sx={{ display: "flex" }}>
          <Typography sx={{ fontSize: 14 }}>Trở về </Typography>
          <Typography
            component={Link}
            to="/authentication/sign-in"
            variant="button"
            sx={{
              fontSize: 14,
              marginLeft: "6px",
              fontWeight: "regular",
              color: "var(--blue-blue-100)",
              cursor: "pointer",
              textTransform: "none",
            }}
          >
            Đăng nhập
          </Typography>
        </SuiBox>
      </SuiBox>
      <SuiBox className="w-100">
        <SuiBox component="form" role="form">
          <SuiBox mb={1}>
            <Typography
              sx={{
                fontSize: "16px",
                color: "var(--gray-100)",
                fontWeight: "regular",
                textTransform: "none",
              }}
              mb={0.7}
            >
              Tên đăng nhập
            </Typography>

            <TextField
              value={userName}
              onChange={(e) => setUserName(e.target.value)}
              sx={{
                width: "100%",
                "& .MuiFilledInput-root": {
                  backgroundColor: "var(--blue-gray-line) !important",
                  border: "none",
                },
                "& .MuiFilledInput-input": {
                  height: "22.02px",
                  width: "100% !important",
                  "::placeholder": {
                    fontStyle: "italic",
                  },
                },
                "& .MuiFilledInput-root:before,& .MuiFilledInput-root:after": {
                  border: "none",
                  content: "none",
                },
                "& label.Mui-focused": {
                  color: "var(--blue-blue-100)",
                },
                "& .MuiInputLabel-root": {
                  color: "#aeaeae",
                },
                "& .Mui-focused": {
                  borderColor: "var(--blue-blue-100) !important",
                },
              }}
              variant="filled"
            />
          </SuiBox>
          <SuiBox mb={1}>
            <Typography
              sx={{
                fontSize: "16px",
                color: "var(--gray-100)",
                fontWeight: "regular",
                textTransform: "none",
              }}
              mb={0.7}
            >
              Nhập mật khẩu hiện tại
            </Typography>
            <InputPassword value={typePasswordOld} onChange={setTypePasswordOld} />
          </SuiBox>
          <SuiBox mb={1}>
            <Typography
              sx={{
                fontSize: "16px",
                color: "var(--gray-100)",
                fontWeight: "regular",
                textTransform: "none",
              }}
              mb={0.7}
            >
              Nhập mật khẩu mới
            </Typography>
            <InputPassword value={typePasswordNew} onChange={setTypePasswordNew} />
          </SuiBox>
          <SuiBox mb={1}>
            <Typography
              sx={{
                fontSize: "16px",
                color: "var(--gray-100)",
                fontWeight: "regular",
                textTransform: "none",
              }}
              mb={0.7}
            >
              Nhập lại mật khẩu mới
            </Typography>
            <InputPassword value={reTypePasswordNew} onChange={setReTypePasswordNew} />
          </SuiBox>
          <SuiBox mb={1}>
            <Typography
              sx={{
                fontSize: "16px",
                color: "var(--gray-100)",
                fontWeight: "regular",
                textTransform: "none",
              }}
              mb={0.7}
            >
              Mã CAPTCHA
            </Typography>
            <SuiBox sx={{ display: "flex", alignItems: "center", width: "100%" }}>
              <TextField
                value={captchaInput || ""}
                onChange={(e) => setCaptchaInput(e.target.value)}
                sx={{
                  marginRight: "10px",
                  width: "100%",
                  "& .MuiFilledInput-root": {
                    backgroundColor: "var(--blue-gray-line) !important",
                    border: "none",
                  },
                  "& .MuiFilledInput-input": {
                    height: "22.02px",
                    width: "100% !important",
                    "::placeholder": {
                      fontStyle: "italic",
                    },
                  },
                  "& .MuiFilledInput-root:before,& .MuiFilledInput-root:after": {
                    border: "none",
                    content: "none",
                  },
                  "& label.Mui-focused": {
                    color: "var(--blue-blue-100)",
                  },
                  "& .MuiInputLabel-root": {
                    color: "#aeaeae",
                  },
                  "& .Mui-focused": {
                    borderColor: "var(--blue-blue-100) !important",
                  },
                }}
                variant="filled"
              />
              <HandleGenCapchaRandomRotate captcha={captchaImg} />
              <Box
                component="img"
                sx={{
                  width: "5%",
                  height: 1,
                }}
                alt="logoSSO"
                src={refreshButton}
                onClick={handleGenCapcha}
              />
            </SuiBox>
          </SuiBox>
          <SuiBox mt={1.7} mb={2} textAlign="center">
            <SuiButton
              size="small"
              color="var(--blue-blue-100)"
              circular
              sx={{
                width: "100% !important",
                background: "var(--blue-blue-100)",
                borderRadius: "15px",
                padding: "8px 24px",
              }}
              onClick={handleLoginAttempt}
            >
              <Typography whiteSpace="nowrap" variant="body2" color="white" fontSize="14px">
                Đổi mật khẩu
              </Typography>
            </SuiButton>
          </SuiBox>
        </SuiBox>
      </SuiBox>
      {isLoginFail && (
        <Snackbar open={isLoginFail} autoHideDuration={3000} onClose={handleCloseNotifyLogin}>
          <Alert severity="error" sx={{ width: "100%" }} onClose={handleCloseNotifyLogin}>
            {error}
          </Alert>
        </Snackbar>
      )}
    </Box>
  );
}

export default ChangePass;
